export const normalizeText = (text: any): string => {
  if (!text) return '';
  return String(text)
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase();
};
